// This is for qa environment
// export const SERVER_ROUTE = "https://ecom.tandhlabs.com/"
// export const API_ROUTE = "https://ecom.tandhlabs.com/api"
// export const CLIENT_ROUTE = "http://localhost:3001"

// export const SERVER_TLD = "https://tns.fireprotectionspecialists.com.au"
// export const SERVER_ROUTE = "https://tns.fireprotectionspecialists.com.au/server/"
// export const API_ROUTE = "https://tns.fireprotectionspecialists.com.au/server/api"
// export const CLIENT_ROUTE = "https://e-commerce-admin-panel-phi.vercel.app"

// This is for development environment
// export const SERVER_TLD = "http://localhost:3000"
// export const SERVER_ROUTE = "http://localhost:3000/"
// export const API_ROUTE = "http://localhost:3000/api"
// export const CLIENT_ROUTE = "http://localhost:3001"

// This is for Production environment
export const SERVER_TLD = "https://api.wedaarana.com"
export const SERVER_ROUTE = "https://api.wedaarana.com/"
export const API_ROUTE = "https://api.wedaarana.com/api"
export const CLIENT_ROUTE = "https://admin.wedaarana.com/"

// This is for QA/Test environment
// export const SERVER_ROUTE = "/"
// export const API_ROUTE = "/api";
// export const CLIENT_ROUTE = "";

